export const menuItems = [
    {
        id: 1,
        label: "الإستقبال و التسجيل",
        icon: "bx-home",
        subItems: [
            {
                id: 2,
                label: "الزيارات",
                link: "/visites",
                parentId: 1
            },
            {
                id: 3,
                label: "التسجيلات",
                link: "/inscriptions",
                parentId: 1
            }
        ]
    },
    {
        id: 11,
        label: "المكون البشري",
        isTitle: true
    },
    {
        id: 12,
        label: "التلاميذ",
        icon: "bx-group",
        subItems: [
            {
                id: 13,
                label: "لائحة التلاميذ المسجلين",
                link: "/eleves",
                parentId: 12
            },
            {
                id: 133,
                label: "لائحة التلاميذ في طور التسجيل",
                link: "/eleves-non-inscrit",
                parentId: 12
            }
            // id: 20
        ]
    },
    {
        id: 14,
        label: "الآباء",
        icon: "bx-user-pin",
        link: "/tuteurs"
    },
    {
        id: 54,
        label: "المكون المالي",
        isTitle: true
    },
    {
        id: 9,
        label: "العمليات البنكية",
        icon: "bx-credit-card-alt",
        link: "/banque-operations"
    },
    {
        id: 10,
        label: "الصندوق",
        icon: "bx-wallet",
        link: "/caisse-operations"
    },
    {
        id: 13,
        label: "تتبع الشيكات",
        link: "/suivi-cheques",
        icon: "bx-credit-card",
        badge: {
            variant: "danger",
            text: "2"
        }
    }
];
